import React from 'react';
import { GridTable } from '@components/common/grid';
import { formatWithDefault, formatCurrency } from '@common/utils';

const GridTableRefund = ({
  id = 'grid-policy-change-refund',
  title,
  data,
  isCurrencyUsd,
}) => (
  <GridTable
    id={id}
    title={title}
    sideTitle={isCurrencyUsd ? '(단위: 달러)' : '(단위: 원)'}
    options={{
      data,
      colNames: ['감액완납 후 경과년수', '도달나이', '감액완납 후 해약환급금'],
      colModel: [
        {
          name: 'progPd',
          index: 'progPd',
          formatter: formatWithDefault(value => `${value}년`),
        },
        {
          name: 'attndAge',
          index: 'attndAge',
          formatter: formatWithDefault(value => `${value}세`),
        },
        {
          name: 'rpuSrndRefndAmnt',
          index: 'rpuSrndRefndAmnt',
          formatter: formatWithDefault(value =>
            formatCurrency(value, isCurrencyUsd, 1000),
          ),
        },
      ],
    }}
  />
);

export default GridTableRefund;
